export default {
  getActualRates: (state) => state.actualRates || [],
}